export default __webpack_public_path__ + "static/media/sync-location.a140caca.svg";